import { createAction } from '../util/index.js'

export const toggleNavMenu = createAction('NAVIGATION_MENU_TOGGLE', { noPayload: true })
export const closeNavMenu = createAction('NAVIGATION_MENU_CLOSE', { noPayload: true })
export const openNavMenu = createAction('NAVIGATION_MENU_OPEN', { noPayload: true })



// WEBPACK FOOTER //
// ./client/src/navigation/actions.js